import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-544252a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-list-empty" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "list-empty-message gutter-s4"
}
const _hoisted_4 = { class: "text-link" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-right ml-s2 text-xs" }, null, -1))

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListEmptyMessage',
  props: {
    action: null,
    noFeeLimit: null,
    isHideZero: { type: Boolean },
    isProvidedOnly: { type: Boolean },
    searchFilter: null
  },
  setup(__props: any) {

const props = __props as {
  action: string;
  noFeeLimit: number | string;
  isHideZero?: boolean;
  isProvidedOnly?: boolean;
  searchFilter?: string | null;
}

const { t } = useI18n();
const router = useRouter();



const noSearchResultMessage = computed(() => {
  return t('singleSide.noSearchResults', {
    searchText: props.searchFilter,
    escapeParameterHtml: true,
  });
});
const messageInserts = computed(() => {
  const inserts = [''];
  if (props.action === 'deposit')
    inserts[0] = props.isHideZero ? t('singleSide.listEmptyMessage.inserts[0]') : '';
  else inserts[0] = props.isProvidedOnly ? t('singleSide.listEmptyMessage.inserts[0]') : '';
  inserts[1] = props.noFeeLimit !== 0 ? t('singleSide.listEmptyMessage.inserts[1]') : '';
  inserts[2] = props.noFeeLimit !== 0 ? t('singleSide.listEmptyMessage.inserts[2]') : '';
  return inserts;
});

const noTokensMessage = computed(() =>
  t(`singleSide.listEmptyMessage.${props.action}`, messageInserts.value),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.searchFilter)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          innerHTML: _unref(noSearchResultMessage)
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_unref(noTokensMessage)), 1),
          _createElementVNode("div", {
            class: "flex align-items-center justify-content-center text-primary clickable",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/portfolios/')))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('singleSide.goToPortfolios')), 1),
            _hoisted_5
          ])
        ]))
  ]))
}
}

})